// extracted by mini-css-extract-plugin
export default {"container":"page404_container__3ua3e","heading":"page404_heading__Jo+Ch","title":"page404_title__mcS4b","list":"page404_list__vV2mk"};